import { tempoApi } from '@/lib/api/tempoApi';
import type { SyncType } from '@/lib/api/types/work-integrations';

export const SyncFailureType = {
  TRANSIENT: 'TRANSIENT',
  PERMANENT: 'PERMANENT',
  UNKNOWN: 'UNKNOWN',
} as const;

export type SyncFailureType = (typeof SyncFailureType)[keyof typeof SyncFailureType];

export interface IntegrationSyncFailedItem {
  integrationId: number;
  sourceItemKey: string | null;
  itemId: number | null;
  message: string;
  type: SyncFailureType;
  failedFields: Record<string, string> | null;
  syncDirection: SyncType;
  failedAt: string;
  syncHistoryId: number | null;
}

export interface SyncFailedItemsPageResponse {
  items: IntegrationSyncFailedItem[];
  totalCount: number;
}

const getSyncFailedItemsForIntegration = async ({
  integrationId,
  page,
  pageSize,
}: {
  integrationId: number;
  page?: number;
  pageSize?: number;
}): Promise<SyncFailedItemsPageResponse> => {
  const searchParams: Record<string, string> = {};
  if (page !== undefined) searchParams.page = String(page);
  if (pageSize !== undefined) searchParams.pageSize = String(pageSize);
  return tempoApi()
    .get(`api/v1/work-integrations/sync-failures/integrations/${integrationId}`, {
      searchParams,
    })
    .json<SyncFailedItemsPageResponse>();
};

const getSyncFailedItemsByItem = async ({
  itemIdOrSourceItemKey,
  page,
  pageSize,
}: {
  itemIdOrSourceItemKey: string;
  page?: number;
  pageSize?: number;
}): Promise<SyncFailedItemsPageResponse> => {
  const searchParams: Record<string, string> = {};
  if (page !== undefined) searchParams.page = String(page);
  if (pageSize !== undefined) searchParams.pageSize = String(pageSize);
  return tempoApi()
    .get(`api/v1/work-integrations/sync-failures/items/${itemIdOrSourceItemKey}`, {
      searchParams,
    })
    .json<SyncFailedItemsPageResponse>();
};

export const SyncFailuresApi = {
  getSyncFailedItemsForIntegration,
  getSyncFailedItemsByItem,
};
